/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AddressSelector_viewer$ref = any;
type RequestModalSelectProject_viewer$ref = any;
export type RequestShippingQuoteForm_viewer$ref = any;
export type RequestShippingQuoteForm_viewer = {
    readonly id: string;
    readonly projects?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly name: string | null;
                readonly portfolio: {
                    readonly serviceId: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": AddressSelector_viewer$ref & RequestModalSelectProject_viewer$ref;
    readonly " $refType": RequestShippingQuoteForm_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "RequestShippingQuoteForm_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "projects",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 200
                            },
                            {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userIds"
                            }
                        ],
                        "concreteType": "ProjectConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProjectEdge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Project",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "name",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "portfolio",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "PortfolioV2",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/)
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "AddressSelector_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "RequestModalSelectProject_viewer",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '4d77e791a8b6f461788042784333cc9b';
export default node;
